import React, { useState, useEffect }  from 'react'
import {config} from '../config'
import Modal from 'react-bootstrap/Modal'
import * as txApi from '../clients/tx-sls-client'
const txdomain = config()['tourneyx-url']
const linodeurl = config()['linode-url']

const StandingsAngler = ({angler,user_information, hideProfileLink = false , is_basscat_tourney}) => {
  //Naveen - 28/sep/2023 Avtar linode image issue-If linodeoption is 1 image load from linode and 0 image load from server.    
    const [linodeoption,setLinodeoption] = useState('');
    useEffect(() =>{
        txApi.getImageSourceOption('load_images_from_linode').then((response)=>{
            setLinodeoption(response);
          })
    },[]);
  //Naveen- 28/sep/2023 TP-344 Jira card :set const for official weight on public leaderboard for BAM/APEX.
  const {user_photo, angler_name, angler_state, is_member, is_logged_in, angler_login,user_id,basscat_team_name,basscat_boat_name,angler_country, official_weight} = angler

  const imgError = (event) => event.target.src = '/react-leaderboard/green28x.png'

  const getAvatar = (image, name) => {
        //Naveen - 28/sep/2023 Avtar linode image issue-
        if(linodeoption != '' && linodeoption == 1){
            return image
                ? <img
          onError={imgError}
          src={`${linodeurl}/angler_uploads/` + 
          image } className="angler_avatar" alt=""/> 
                : <div className="ai-icon">{ (name !== null) && (name !== undefined)  ? name.split(" ").map(n => n[0]).join("") : '' }</div>
        }else{
            console.log('Elseeeee-:',image);
    return image 
      ? <img
          onError={imgError}
          src={`${txdomain}/app/lib/php/timthumb.php?src=${txdomain}/app/lib/uploads/angler_uploads/` + 
          image + '&amp;h=50&amp;w=50&amp;zc=1'} className="angler_avatar" alt=""/> 
      : <div className="ai-icon">{ name !== null ? name.split(" ").map(n => n[0]).join("") : '' }</div>
  }
}

  const getBassCatTeamName = (basscat_team_name) => {
   
    if( basscat_team_name !== null ){
      return basscat_team_name;
    }else{
      return '';
    }

  }

  const getBassCatBoatName = ( basscat_boat_name ) => {

    if( basscat_boat_name !== null ){
      var boat_number = `( Boat : ${basscat_boat_name.toUpperCase()} )`;

      return boat_number ;
    }else{
      return '';
    }

  }
  //Naveen- 28sep2023 TP-344 Jira card :To show official weight on public leaderboard for BAM/APEX tournament [react code].
const getTournamentTypeDetails= ( ) => {
  if(  ( (official_weight !== null && official_weight !== "" && official_weight !== undefined && official_weight != 0  && official_weight != 0.0 && official_weight !== 0.00  ))){
    return <div class="official_weight_leaderboard"><label>Official Weight:&nbsp;</label>{official_weight}lbs</div>;
  }else{
    return '';
  }

}
  const angleDisplay = 
    <>
    <div className="angler-info-container">
      <div className="ang-img-container left">
      {getAvatar(user_photo, angler_name)}
        {is_logged_in === "1" ? <span className="logged_in_dot"></span> : <span/>}
      </div>
      <div className="ang-data">
      {
         (user_information && user_information.role === '1') ?

        <div>
            {(is_member === "1" || is_member === 1 ) ? <img src="/leaderboard/X.png" alt="TourneyX" className="stats"/> : <span/>}
            {/* <span className="angler-name">{angler_name}&nbsp;({user_id}) </span> */}
            {/* Chaitraly 27/Feb/2025 :: TP-404 client requirement - Render angler name on new lines */}
            <span className="angler-name">
              {angler_name.split(", ").map((name, index) => (
                <span key={index}>
                  {name}
                  <br />
                </span>
              ))}
              &nbsp;({user_id})
            </span>
        </div>
        :
        <div>
            {(is_member === "1" || is_member === 1 ) ? <img src="/leaderboard/X.png" alt="TourneyX" className="stats"/> : <span/>}
            {/* <span className="angler-name">{angler_name}</span> */}
            {/* Chaitraly 27/Feb/2025 :: TP-404 client requirement - Render angler name on new lines */}
            <span className="angler-name">
              {angler_name.split(", ").map((name, index) => (
                <span key={index}>
                  {name}
                  <br />
                </span>
              ))}
            </span>
        </div>

      }
     
      <div>
        {is_basscat_tourney === "1" ?  <span className="basscat-team-name">{is_basscat_tourney ?  getBassCatTeamName(basscat_team_name) : ''}</span> : ''}
      </div>

      <div>
        {is_basscat_tourney === "1" ?  <span className="basscat-boat-name">{is_basscat_tourney ?  getBassCatBoatName(basscat_boat_name) : ''}</span> : ''}
      </div>
      </div>
    </div>
      {//Naveen- 28sep2023 TP-344 Jira card :
      }
      <div class="official_weight_state">{is_basscat_tourney === "1" ? '': <small>{angler_state && angler_country ? `(${angler_state}, ${angler_country})` : ''}</small>}</div>
      <div>
        {
          getTournamentTypeDetails(  )
        }
      </div>
    </>

  return(
    <td className="standings-angler">
      {
        !hideProfileLink 
          ? <a href={`${txdomain}/app/profile/` + angler_login}>{angleDisplay}</a>
          : <> {angleDisplay} </>
      }
    </td>
  )
}

export default StandingsAngler